// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3LTDQ","disabled":"Button_disabled__1mnMp","cantEdit":"Button_cantEdit__1FTYb"};